"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Stormfallen_OnCompanionAddedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let Effect_Stormfallen_OnCompanionAddedEventHandlerScript = class Effect_Stormfallen_OnCompanionAddedEventHandlerScript {
    run(sequence, container, handler, event) {
        if ((0, Random_1.randomPercent)() <= handler.args.scriptArgs.percentChance) {
            container.applyEffect(sequence, handler.args.scriptArgs.attackerId, event.args.companionId, new core_1.DeathEffectArgs(), Duration_1.Duration.Permanent, true);
        }
    }
};
Effect_Stormfallen_OnCompanionAddedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("DestroyCompanion_OnAdded")
], Effect_Stormfallen_OnCompanionAddedEventHandlerScript);
exports.Effect_Stormfallen_OnCompanionAddedEventHandlerScript = Effect_Stormfallen_OnCompanionAddedEventHandlerScript;
